import paths, { rootPaths } from "./paths";

export const dashboardRoutes = {
  label: "",
  children: [
    {
      name: "Dashboard",
      active: true,
      icon: "chart-pie",
      to: "/",
      soon: false,
    },
    {
      name: "Eligibility",
      icon: "check-circle",
      active: true,
      children: [
        {
          name: "Eligibility Check",
          active: true,
          to: paths.eligibilityCheck,
        },
        {
          name: "Eligibility Check List",
          active: true,
          to: paths.eligibilityCheckList,
        },
      ],
    },
    {
      name: "Preauthorization",
      icon: "calendar-check",
      active: true,
      children: [
        {
          name: "Preauthorization",
          active: true,
          to: paths.preauthorization,
        },
        {
          name: "Preauthorization List",
          active: true,
          to: paths.preauthorizationList,
        },
      ],
    },
    {
      name: "Claims",
      icon: "file-alt", // Changed from "file-invoice"
      active: true,
      children: [
        {
          name: "Claim Dashboard",
          active: true,
          to: paths.claimDashboard,
          soon: false,
        },
        {
          name: "Claims List",
          active: true,
          to: paths.claimsList,
        },
        {
          name: "Prepare Claim",
          active: true,
          to: paths.preapareClaim,
        },
        {
          name: "Create Claim",
          active: true,
          to: paths.createClaim,
        },
        {
          name: "Claim Imports",
          active: true,
          to: paths.cliamPollsImports,
        },
        {
          name: "Claim Payment",
          active: true,
          to: paths.payment,
        },
      ],
    },
    {
      name: "Polls",
      icon: "poll",
      active: true,
      to: paths.cliamPolls,
    },
    {
      name: "Patients",
      icon: "users",
      active: true,
      to: paths.patientList,
    },

    {
      name: "Practitioners",
      icon: "user",
      active: true,
      children: [
        {
          name: "Practitioners List",
          active: true,
          to: paths.practitionerList,
        },
        {
          name: "Add Practitioner",
          active: true,
          to: paths.addPractitionerList,
        },
        {
          name: "Practitioner Import",
          active: true,
          to: paths.practitionerImports,
        },
      ],
    },
    {
      name: "Prices Management",
      icon: "dollar-sign",
      active: true,
      children: [
        {
          name: "Price List",
          active: true,
          to: paths.priceList,
        },
        {
          name: "Add Price",
          active: true,
          to: paths.addPriceList,
        },
        {
          name: "Price Import",
          active: true,
          to: paths.priceImport,
        },
      ],
    },
    {
      name: "Users",
      icon: "user",
      active: true,
      children: [
        {
          name: "Users List",
          active: true,
          to: paths.employeeList,
        },
        {
          name: "Add User",
          active: true,
          to: paths.addEmpolyeeList,
        },
        {
          name: "User Import",
          active: true,
          to: paths.employeeImport,
        },
      ],
    },
    {
      name: "Payers",
      soon: true,
      icon: "sliders-h",
      active: true,
      to: paths.insuranceCompanyRoot,
    },
    {
      name: "User Permissions",
      icon: "lock",
      active: true,
      to: rootPaths.userPermissionsRoot,
    },
    {
      name: "General Settings",
      icon: "cog",
      active: true,
      children: [
        {
          name: "Branch",
          active: true,
          children: [
            {
              name: "Branch List",
              active: true,
              to: paths.branchList,
            },
            {
              name: "Add Branch",
              active: true,
              to: paths.addBranch,
            },
            {
              name: "Branch Import",
              active: true,
              to: paths.branchImport,
            },
          ],
        },
        {
          name: "Roles",
          active: true,
          to: paths.systemPrivillage,
        },
        {
          name: "Field Settings",
          active: true,
          to: paths.fieldSettings,
        },
        {
          name: "ICD Codes",
          active: true,
          to: paths.icdsCodeSettings,
        },
      ],
    },
  ],
};

export default [dashboardRoutes];
